var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentimentDrivers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.87 46.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 603",
    d: "M0 0v36.43h26.14l-.87 10.05 16.15-10.05h6.45V0zm44.87 33.43h-3.45a3.082 3.082 0 00-1.59.45l-11.05 6.88.35-4.07a3.01 3.01 0 00-.78-2.29 3 3 0 00-2.21-.97H3V3h41.87z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 604",
    d: "M39.86 13.77l-.9-2.86-18.01 5.64a7.267 7.267 0 00-6.33-3.7 7.1 7.1 0 00-2.17.33 7.254 7.254 0 00-4.75 9.09 7.244 7.244 0 006.92 5.09 7.424 7.424 0 002.17-.33 7.245 7.245 0 005.05-7.62l5.75-1.8 1.2 3.83 5.26-1.65-1.2-3.82 1.75-.55 1.72 5.49 5.26-1.65zM15.89 24.16a3.922 3.922 0 01-1.27.2 4.24 4.24 0 01-4.06-2.98 4.268 4.268 0 012.79-5.34 4.251 4.251 0 011.27-.19 4.24 4.24 0 014.06 2.98 4.257 4.257 0 01-2.792 5.33z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentDrivers);
export default __webpack_public_path__ + "static/media/SentimentDrivers.6cecb511.svg";
export { ForwardRef as ReactComponent };